import * as React from 'react';
import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

export default function Caixa() {
    const navigate = useNavigate();
    const location = useLocation();

    const [registroEmEdicao, setRegistroEmEdicao] = useState(null);

    let value = 0;
    if (location.pathname.endsWith('/caixa-novo')) value = 1;
    else if (location.pathname.endsWith('/caixa-xlsx')) value = 2;

    const handleChange = (event, newValue) => {
        if (newValue === 0) navigate('/caixa/caixa-caixa');
        else if (newValue === 1) navigate('/caixa/caixa-novo');
        else if (newValue === 2) navigate('/caixa/caixa-xlsx');
    };

    const handleEditar = (registro) => {
        setRegistroEmEdicao(registro);
        navigate('/caixa/caixa-novo');
    };

    const handleSalvoOuCancelado = () => {
        setRegistroEmEdicao(null);
        navigate('/caixa/caixa-caixa');
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Caixa" />
                    <Tab label={registroEmEdicao ? "Novo / Editar" : "Novo"} />
                    <Tab label="XLSX" />
                </Tabs>
            </Box>
            <Outlet context={{ registroEmEdicao, handleEditar, handleSalvoOuCancelado }} />
        </Box>
    );
}